import type { FactState } from '../../lib/profile/types';
import { FACT_STATE_LABEL } from '../../lib/profile/types';
import { Badge } from './Badge';

const TONE: Record<FactState, 'gap' | 'danger' | 'verified'> = {
  'needs-review': 'gap',
  corrected: 'danger',
  confirmed: 'verified',
};

/**
 * Provenance label for a single fact. The text is the exact product label so
 * accessibility and tests never depend on colour alone. `edited` adds a
 * draft-only suffix without changing the underlying state.
 */
export function FactBadge({ state, edited = false }: { state: FactState; edited?: boolean }) {
  return (
    <Badge tone={TONE[state]} dot>
      {edited ? `${FACT_STATE_LABEL[state]} · edited in draft` : FACT_STATE_LABEL[state]}
    </Badge>
  );
}
